import React from "react";
import Heading from "../components/Common/Heading/Heading";
import JobCard from "../components/JobCard";
import { useState, useEffect } from "react";
import axios from "axios";

const BrowseJobs = () => {
  const [browseJobs, setBrowseJobs] = useState([]);
  const [currentMonthJobs, setCurrentMonthJobs] = useState(null);
  const [totalActiveJobs, setTotalActiveJobs] = useState(null);
  const [visibleJobs, setVisibleJobs] = useState(6); // Initially show 6 cards

  const handleShowAll = () => {
    setVisibleJobs(browseJobs.length); // Show all cards
  };

  useEffect(() => {
    const getBrowseJobs = () => {
      axios
        .post("https://hrms-api.apisod.ai/api/job-list-count-by-group", {})
        .then((res) => {
          // console.log("browse jobs", res.data);
          setBrowseJobs(res.data.jobFunctions);
          setCurrentMonthJobs(res.data.currentMonthJobs);
          setTotalActiveJobs(res.data.totalActiveJobs);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    getBrowseJobs();
  }, []);

  return (
    <div className="browse-jobs-area pt-3">
      <div className="container">
        <div className="section-title text-center">
          <Heading level={2} className="text-center">
            Browse Jobs By Specialisms
          </Heading>
          <div className="bar m-auto"></div>
          <p className="m-auto">
            {totalActiveJobs} jobs live{" "}
            {currentMonthJobs > 0 && ` - ${currentMonthJobs} added this month.`}
          </p>
        </div>

        <div className="row pt-45 justify-content-center">
          {browseJobs.slice(0, visibleJobs).map((category, index) => (
            <div key={index} className="col-lg-4 col-sm-6">
              <JobCard
                icon={category.icon}
                title={category.name}
                href={category.href}
                positions={category.total}
              />
            </div>
          ))}
          {browseJobs.length > visibleJobs && (
            <div className="col-lg-12 text-center">
              <div className="browse-btn">
                <a onClick={handleShowAll} style={{ cursor: "pointer" }}>
                  Browse All Categories{" "}
                  <i className="ri-arrow-right-s-line"></i>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrowseJobs;
